@if (model()) {
  <div id="social" class="d-none d-sm-block" style="padding-left: 10px">
    <div class="contactslide">
      <div class="boxtitle">
        <img
          [src]="imgUrl"
          [alt]="
            model().contactImgTitle.useTranslation
              ? (model().contactImgTitle.text | translate)
              : model().contactImgTitle.text
          "
          [title]="
            model().contactImgTitle.useTranslation
              ? (model().contactImgTitle.text | translate)
              : model().contactImgTitle.text
          " />
      </div>
      <div class="bodytext">
        <div
          class="headline"
          [innerHtml]="
            model().hiddenText.useTranslation ? (model().hiddenText.text | translate) : model().hiddenText.text
          "></div>
        <table>
          <tbody>
            <tr>
              <td class="icon"><i [class]="model().phoneIcon"></i></td>
              <td>{{ model().phoneNumberString }}<br /></td>
            </tr>
            <tr>
              <td class="icon"><i [class]="model().emailIcon"></i></td>
              <td>
                <a
                  [href]="model().contactLink.linkUrl"
                  [innerHtml]="
                    model().contactLink.useTranslation
                      ? (model().contactLink.text | translate)
                      : model().contactLink.text
                  "></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
